import React from 'react';
import { Home24Regular } from '@fluentui/react-icons';
import { type CustomerFormBag } from './types';
import { useSectionStyles } from './styles';
import AddressFields from '../AddressFields';

interface AddressSectionProps {
  form: CustomerFormBag;
  /** Hide the title icon when the section is hosted in a context that
   *  already provides framing (e.g. the profile page's card wrapper). */
  showIcon?: boolean;
}

/**
 * Customer-form wrapper around the shared `AddressFields`. Adds the section
 * title above the six address fields. The fields themselves live in
 * `AddressFields` and are reused by the order's billing-address dialog.
 */
const AddressSection: React.FC<AddressSectionProps> = ({ form, showIcon = true }) => {
  const styles = useSectionStyles();
  const {
    addressLine1, setAddressLine1,
    addressLine2, setAddressLine2,
    city, setCity,
    region, setRegion,
    postalCode, setPostalCode,
    country, setCountry,
    setFieldErrors,
    triggerSave,
  } = form;

  return (
    <>
      <div className={styles.sectionTitle}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
          {showIcon && <Home24Regular />}Billing address
        </span>
      </div>

      <AddressFields
        addressLine1={addressLine1}
        onAddressLine1Change={setAddressLine1}
        addressLine2={addressLine2}
        onAddressLine2Change={setAddressLine2}
        city={city}
        onCityChange={setCity}
        region={region}
        onRegionChange={setRegion}
        postalCode={postalCode}
        onPostalCodeChange={setPostalCode}
        country={country}
        onCountryChange={setCountry}
        onCommit={triggerSave}
        onPostalErrorChange={(err) =>
          setFieldErrors((prev) => {
            if (err) return { ...prev, postalCode: err };
            const { postalCode: _drop, ...rest } = prev;
            return rest;
          })
        }
        idPrefix="customer-address"
      />
    </>
  );
};

export default AddressSection;
